// Import everything from autoload

// import local dependencies
import Router from './util/Router';
// import barbaInit from './barbainit';
import common from './routes/common';
import home from './routes/home';
import lp1 from './routes/lp1';
import lp2 from './routes/lp2';
import lp3 from './routes/lp3';
import signUp from './routes/sign-up';
import about from './routes/about';
import contact from './routes/contact';
import privacy from './routes/privacy';
import thankYou from './routes/thank-you';
import thankYouTwo from './routes/thank-you';
import featured from './routes/featured';
import single from './routes/single';
import templateSignup from './routes/template-signup';
import templateIsfor from './routes/template-isfor';
import templateLegal from './routes/template-legal';
import timer from './routes/timer';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About page
  about,
  // LP1
  lp1,
  // LP2
  lp2,
  // LP3
  lp3,
  // Sign up
  signUp,
  // Contact page
  contact,
  // Privacy page
  privacy,
  // Thank you
  thankYou,
  // Thank you two
  thankYouTwo,
  // Featured
  featured,
  // Single
  single,

  templateSignup,

  templateIsfor,

  templateLegal,

  timer,
});

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents()
});



// WEBPACK FOOTER //
// ./scripts/main.js